import { NotFoundPage } from './components/404/404.component';
import { MainNavComponent } from './components/main-nav/main-nav.component';

import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { HomeComponent } from './components/home/home.component';
import { MenuComponent } from './components/menu/menu.component';
import { TramitesComponent } from './components/tramites/tramites.component';

import { ClaveUnicaComponent } from 'src/app/components/claveunica/claveunica.component';
import { ClaveUnicaTokenComponent } from 'src/app/components/claveunica/token/claveunica_token.component';

import { TabsComponent } from './components/formulario/tabs/tabs.component';

import { InicioComponent } from './components/inicio/inicio.component';
import { CertificadosComponent } from './components/certificados/certificados.component';

import { RegistroComponent } from './components/home/registro/registro.component';

//CERTIFICADOS
import { SolicitanteComponent } from './components/certificados/solicitante/solicitante.component';
import { PropiedadesComponent } from './components/certificados/propiedades/propiedades.component';
import { Tipos_certificadosComponent } from './components/certificados/tipos_certificados/tipos_certificados.component';
import { CorviComponent } from './components/certificados/corvi/corvi.component';
import { Resumen_certComponent } from './components/certificados/resumen_cert/resumen_cert.component';
import { Navbar_certComponent } from './components/certificados/navbar_cert/navbar_cert.component';
import { Formulario81Component } from './components/formulario/formulariosAntiguos/formulario81/formulario81.component';

//SEGUIMIENTO EXPEDIENTE
import { Seguimiento_expedienteComponent } from './components/seguimiento_expediente/seguimiento_expediente.component';
import { Acta_expedienteComponent } from './components/seguimiento_expediente/acta_expediente/acta_expediente.component';
import { PresentacionComponent } from './components/presentacion/presentacion.component';
import { ForgotPassComponent } from './components/home/forgot-pass/forgot-pass.component';
import { PagoDerechosComponent } from './components/pago-derechos/pago-derechos.component';
import { Solicitud_certificadosComponent } from './components/solicitud_certificados/solicitud_certificados.component';
import { IngresoObservacionesComponent } from './components/ingreso-observaciones/ingreso-observaciones.component';
import { SeguimientoExpComponent } from './components/seguimiento-exp/seguimiento-exp.component';
import { SeguimientoCertificadosComponent } from './components/seguimiento-certificados/seguimiento-certificados.component';
import { SegCertProvComponent } from './components/seg-cert-prov/seg-cert-prov.component';
import { IngresoAscensoresComponent } from './components/ascensores/ingreso-ascensores/ingreso-ascensores.component';
import { MantencionAscensoresComponent } from './components/ascensores/mantencion-ascensores/mantencion-ascensores.component';

export const appRoutes: Routes = [

    {path: '', component: InicioComponent},
    // { path: '', component: PresentacionComponent },
    { path: 'activate/:token', component: InicioComponent },
    { path: 'expedientes', component: MainNavComponent },
    { path: 'clave_unica', component: ClaveUnicaComponent },
    { path: 'clave_unica_token', component: ClaveUnicaTokenComponent },
    { path: 'certificados', component: Solicitud_certificadosComponent },
    { path: 'propiedades', component: PropiedadesComponent },
    { path: 'solicitante', component: SolicitanteComponent },
    { path: 'tipos_certificados', component: Tipos_certificadosComponent },
    { path: 'corvi', component: CorviComponent },
    { path: 'resumen_cert', component: Resumen_certComponent },
    { path: 'navbar_cert', component: Navbar_certComponent },
    { path: 'menu', component: MenuComponent },
    { path: 'login', component: HomeComponent },
    { path: 'forgotPass', component: ForgotPassComponent }, //desarrollo de componente recuperacion de contraseña
    { path: 'tramites', component: TramitesComponent },
    { path: 'tabs', component: TabsComponent },
    { path: 'registro', component: RegistroComponent },
    { path: 'inicio', component: InicioComponent },
    { path: 'seguimiento_expediente', component: SeguimientoExpComponent },
    { path: 'seguimiento_certificados', component: SeguimientoCertificadosComponent },
    { path: 'pago_calculo_derecho', component: PagoDerechosComponent },
    { path: 'acta_expediente', component: Acta_expedienteComponent },
    { path: 'seguimiento_certificados_pagos', component: SegCertProvComponent },
    { path: 'ingreso_observaciones', component: IngresoObservacionesComponent },
    { path: 'ingreso_ascensores', component:  IngresoAscensoresComponent },
    { path: 'mantencion_ascensores', component:  MantencionAscensoresComponent },
    { path: '404', component: NotFoundPage },
    { path: '**', redirectTo: '/inicio' }
];

export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, { useHash: true });
